module.exports = __webpack_public_path__ + "9570dc35c8c95e7072403945bc9f7b42.pdf";